/**
 * Test Data Generator - Generates realistic time series data for charts
 */

export const generateTimeSeriesData = (days = 90) => {
  const data = [];
  const today = new Date();
  
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    
    data.push({
      date: date.toISOString().split('T')[0],
      hours: Math.floor(Math.random() * 12) + 2, // 2-14 hours
      completion: Math.floor(Math.random() * 30) + 50, // 50-80%
      tasks: Math.floor(Math.random() * 6) + 1, // 1-6 tasks
      productivity: Math.floor(Math.random() * 40) + 60 // 60-100%
    });
  }
  
  return data;
};

export const generateWeeklyData = (weeks = 12) => {
  const data = [];
  const today = new Date();
  
  for (let i = weeks - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i * 7);
    const weekNum = Math.floor((365 - i * 7) / 7);
    
    data.push({
      week: `Week ${weekNum}`,
      date: date.toISOString().split('T')[0],
      hours: Math.floor(Math.random() * 40) + 20, // 20-60 hours/week
      tasksCompleted: Math.floor(Math.random() * 25) + 10,
      quality: Math.floor(Math.random() * 25) + 75,
      efficiency: Math.floor(Math.random() * 20) + 70
    });
  }
  
  return data;
};

export const generateMonthlyData = (months = 12) => {
  const data = [];
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const today = new Date();
  
  for (let i = months - 1; i >= 0; i--) {
    const monthIndex = (today.getMonth() - i + 12) % 12;
    
    data.push({
      month: monthNames[monthIndex],
      hours: Math.floor(Math.random() * 80) + 100, // 100-180 hours/month
      goals: Math.floor(Math.random() * 3) + 2,
      goalsCompleted: Math.floor(Math.random() * 2) + 1,
      revenue: Math.floor(Math.random() * 50000) + 30000,
      growth: Math.floor(Math.random() * 15) + 5
    });
  }
  
  return data;
};

export const generateCategoryData = () => {
  const categories = ['Development', 'Testing', 'Documentation', 'Meetings', 'Learning'];
  return categories.map(cat => ({
    category: cat,
    hours: Math.floor(Math.random() * 40) + 5,
    tasks: Math.floor(Math.random() * 15) + 2,
    completion: Math.floor(Math.random() * 30) + 50
  }));
};

export const generateGoalsData = () => {
  const goals = [
    { id: 1, title: 'Complete Q1 Features', target: 100, progress: 75 },
    { id: 2, title: 'Improve Code Quality', target: 100, progress: 68 },
    { id: 3, title: 'Team Training Program', target: 100, progress: 85 },
    { id: 4, title: 'Performance Optimization', target: 100, progress: 42 },
    { id: 5, title: 'Documentation Update', target: 100, progress: 90 }
  ];
  return goals;
};

export const generateProductivityMetrics = () => {
  const metrics = {
    totalHours: 487,
    averageDaily: 5.4,
    tasksCompleted: 142,
    completionRate: 76.5,
    streak: 23,
    efficiency: 82,
    focusScore: 88.5
  };
  return metrics;
};

export const getMetricsComparison = (period = 'week') => {
  const metrics = {
    current: Math.floor(Math.random() * 40) + 60,
    previous: Math.floor(Math.random() * 40) + 50,
    change: Math.floor(Math.random() * 20) - 10
  };
  
  const previous = metrics.previous;
  const current = metrics.current;
  metrics.change = ((current - previous) / previous * 100).toFixed(1);
  metrics.trend = metrics.change >= 0 ? 'up' : 'down';
  
  return metrics;
};
